
<div class="container col-xxl-8 px-4 py-5 landing-content" >
    <div class="row align-items-center g-5 py-5">
  
        <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">Disclaimer</h1>
        <div class="row align-items-center g-5">
          <h2 class="display-5 lh-1 mb-3">1. Service Data Handling</h2>
          <p>Where necessary to provide the Service, we store RTK Base data and related telemetry as instructed by the Customer.</p>

          <h2 class="display-5 lh-1 mb-3">2. Protocol Limitation</h2>
          <p>Certain protocol versions (e.g., NTRIP v1) do not support encryption in transit for device-to-service transmission. Once received by our Service, data is encrypted at rest.</p>

          <h2 class="display-5 lh-1 mb-3">3. No Customer Data Backups</h2>
          <p>We do not back up customer data. Customers are responsible for exporting or preserving any data they may need beyond the retention window.</p>

          <h2 class="display-5 lh-1 mb-3">4. Limitation of Liability</h2>
          <p>We are not liable for unavailability, loss, or corruption of data arising from third-party networks, protocol limitations, or Customer’s configurations, except to the extent required by applicable law.</p>
      </div>

    </div>
  </div>